<template lang="html">
    <div>
       <v-toolbar text color="white">
        <v-toolbar-title>BORDER CONTROL POSTS CODES ({{getData.length}})</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
        <br>
         <v-card-title class="justify-content-end">
            <v-flex md4 pr-2 >
                <v-text-field v-model="search" label="Search"
                append-icon="mdi-magnify" single-line hide-details ></v-text-field>
            </v-flex>
        </v-card-title>
      <v-data-table :headers="headers" :items="getData" 
           :search="search" class="elevation-1">
        <template v-slot:item="props">
          <tr>
            <td class="text-xs-right" >{{ props.item.borderControlPost }}</td>
            <td class="text-xs-right">{{ props.item.contactdetails }}</td>
            <td class="text-xs-right">{{ props.item.traceScode }}</td>
            <td class="text-xs-right">{{ props.item.inspectioncentres }}</td>
            <td class="text-xs-right">{{ props.item.categories }}</td>
            <td class="text-xs-right">{{ props.item.additionalspecificationsdesignation }}</td>
            <td class="text-xs-right">{{ props.item.borderControlPostType }}</td>
          </tr>
        </template>
<template v-slot:no-data>
          <span>No data found</span>
        </template>
</v-data-table>

</div>
</template>

<script>
    import MasterScreenService from "../../services/master-screenservices"

    export default {
        name: 'UKCustomsOffices',
        data() {
            return {
                search: '',
                getData: [],
                headers: [{
                    text: "Border Control Post",
                    align: "left",
                    sortable: true,
                    value: "borderControlPost"
                }, {
                    text: "Contact Details",
                    align: "left",
                    sortable: true,
                    value: "contactdetails"
                }, {
                    text: "TRACES Code",
                    align: "left",
                    sortable: true,
                    value: "traceScode"
                }, {
                    text: "Inspection Centres",
                    align: "left",
                    sortable: true,
                    value: "inspectioncentres"
                }, {
                    text: "Categories",
                    align: "left",
                    sortable: true,
                    value: "categories"
                }, {
                    text: "Specification for Destination",
                    align: "left",
                    sortable: true,
                    value: "additionalspecificationsdesignation"
                }, {
                    text: "Border Control Type",
                    align: "left",
                    sortable: true,
                    value: "borderControlPostType"
                }, ],
            }
        },
        computed: {},
        created() {
            MasterScreenService.getBorderControlPosts().then(response => {
                    this.getData = response.data;
                    console.log(this.getData);
                })
                .catch(e => {
                    console.log(e);
                });
        },

        methods: {}
    }
</script>

<style>
    .justify-content-end {
        justify-content: Flex-end;
    }
</style>